import { sumBy } from 'lodash';
import { MeasureEnum } from 'models/enums/measureEnum';
import { ProductTypeEnum } from 'models/enums/productTypeEnum';

/**
 * Функция получения наименования единицы измерения
 *
 * @param {MeasureEnum} measure перечисление типа единицы измерения
 * @param {boolean} [short=false] опциональный параметр, указывающий на необходимость получения сокращенного наименования
 * @returns {string} наименование единицы измерения
 */
export function getMeasureName(measure: MeasureEnum, short = false): string {
  switch (measure) {
    case MeasureEnum.Piece:
      return short ? 'шт' : 'Штука';

    case MeasureEnum.Meter:
      return short ? 'м' : 'Метр';

    case MeasureEnum.LinearMeter:
      return short ? 'пог.\u00A0м' : 'Погонный метр';

    case MeasureEnum.SquareMeter:
      return short ? 'м²' : 'Квадратный метр';

    default:
      return `ಠ╭╮ಠ`;
  }
}

/**
 * Функция получения наименования типа продукта
 *
 * @param {ProductTypeEnum} type перечисление типа продукта
 * @returns {string} наименование типа продукта
 */
export function getProductTypeName(type: ProductTypeEnum): string {
  switch (type) {
    case ProductTypeEnum.Simple:
      return 'Простой';
    case ProductTypeEnum.Composite:
      return 'Составной';

    default:
      return `ಠ╭╮ಠ`;
  }
}

/**
 * Функция изменения количества продукта
 *
 * @param {object} product объект продукта, содержащий поля count, price, sum
 * @param {number} newCount новое значение количества продукта
 * @returns {void}
 */
export function changeProductCount<
  T extends { count: number; price: number; sum: number }
>(product: T, newCount: number): void {
  if (newCount >= 0 && !isNaN(newCount)) {
    product.count = newCount;
    product.sum = newCount * product.price;
  } else {
    throw new Error('Invalid new count');
  }
}

/**
 * Функция изменения стоимости продуктов
 *
 * @param {object} products массив продуктов, содержащий поле sum
 * @returns {number} Общая стоимость всех продуктов
 */
export function getTotalSum<T extends { totalSum: number }>(products: T[]): number {
  return sumBy(products, (p) => p.totalSum);
}
